import React, { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'components/Button'
import { Text } from 'components/Text'
import { getIcon } from 'features/Project/components/Wizards/utils'
import { Flex } from 'components/Flex'
import styles from './SeePonderaReport.module.scss'
import { AreaTools } from 'models/editor'
import { useParams } from 'react-router-dom'

export const SeePonderaReport: FC = () => {
  const { t } = useTranslation()

  const { projectId } = useParams()

  const [latP, setlat] = React.useState('')
  const [lonP, setlon] = React.useState('')
  const [urlP, seturl] = React.useState('')

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var url =
      'https://mapserver.descifra.global/v1/getQueryRes/public.reportproject?columns=*&filter=project_id=' +
      projectId // eslint-disable-next-line react-hooks/exhaustive-deps
    if (window.location.href.includes('projects')) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      fetch(url) // eslint-disable-next-line react-hooks/exhaustive-deps
        .then((response) => response.json()) // eslint-disable-next-line react-hooks/exhaustive-deps
        .then(
          (data) => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            var url1 = data[0]['url']
            var lat1 = data[0]['lat']
            var lon1 = data[0]['lon']

            setlat(lat1)
            setlon(lon1)
            seturl(url1)
          }, // eslint-disable-next-line react-hooks/exhaustive-deps
        ) // eslint-disable-next-line react-hooks/exhaustive-deps
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // eslint-disable-next-line react-hooks/exhaustive-deps

  function openReport() {
    if (urlP !== undefined) {
      window.open(String(urlP), 'Reporte Pondera')
    }
  }

  return (
    <Flex justify="between" align="center" gap="md" className={styles.confirmation}>
      <Flex justify="center" align="center" className={styles.iconContainer}>
        {getIcon(AreaTools.POINT_PONDERA)}
      </Flex>
      <div>
        <Text className={styles.title} weight="strong">
          {t(`confirmation_banner.PROJECT_CREATE.POINT_PONDERA.title`)}
        </Text>

        <Text className={styles.center}>
          {t('confirmation_banner.latitude')} {latP}, {t('confirmation_banner.longitude')} {lonP}
        </Text>
      </div>
      <Flex gap="sm">
        <Button onClick={openReport}>{t('create_project.pondera_dialog.title')}</Button>
      </Flex>
    </Flex>
  )
}

SeePonderaReport.displayName = 'SeePonderaReport'
